import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import AuthContext from '@/product/context/auth/authContext'
import SignContext from '@/custom/context/signContext'

const FooterLinks = ({ className, data }) => {
    const { handleLoginPopup } = useContext(SignContext)
    const { footerTitle, lists } = data
    const authContext = useContext(AuthContext)
    const { isAuthenticated, logout } = authContext

    return (
        <div className="col-md-3 col-sm-6 col-12 text-center footerNavlnks">
            <h4 className="footer-link-title">{footerTitle}</h4>
            <ul
                className={footerTitle == 'Stay connected' ? 'footer-nav social-nav' : 'footer-nav'}
            >
                {lists.map((list) => (
                    <li key={`footer-list-key${list.id}`} className="footer-nav-list">
                        {list.type === 'login_logout' ? (
                            <a
                                className="footer-link"
                                onClick={isAuthenticated ? logout : handleLoginPopup}
                            >
                                {isAuthenticated ? 'Logout' : 'Login'}
                            </a>
                        ) : list.img ? (
                            <a
                                href={list.path}
                                className="footer-link"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={list.img} alt={list.title} />
                            </a>
                        ) : list.external ? (
                            <a key={`nav-${list.id}`} href={`${list?.path || '#'}`}>
                                {list.title}
                            </a>
                        ) : (
                            <Link
                                to={list.path}
                                target={
                                    list.path == '/terms-and-conditions' ||
                                    list.path == '/privacy-policy' ||
                                    list.path == '/contact-us'
                                        ? '_blank'
                                        : null
                                }
                                className={`footer-link ${
                                    isAuthenticated != list.isLoggedIn &&
                                    list.isLoggedIn == false &&
                                    'd-none'
                                }`}
                            >
                                {list.title}
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default FooterLinks
